export default __webpack_public_path__ + "f24712e58047e737d81170b1944265d8.svg";